import React from 'react';
import { useNavigate } from 'react-router-dom';
import FormDepot from '../components/FormDepot';

export default function DepotPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'DM Sans', sans-serif", padding: '28px 20px' }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <button onClick={() => navigate(-1)} style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: '#4F46E5', fontWeight: 600, fontSize: 14,
          marginBottom: 18, display: 'flex', alignItems: 'center', gap: 6,
          fontFamily: 'inherit', padding: 0,
        }}>
          ← Retour
        </button>

        <div style={{ background: 'white', borderRadius: 20, padding: 28, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#1e293b', marginBottom: 24 }}>
            🏁 Créer une course
          </div>
          <FormDepot onSuccess={() => navigate('/mes-colis')} />
        </div>
      </div>
    </div>
  );
}
